import { wrappingInputRule } from 'prosemirror-inputrules';
import { blType, olType } from './utils';
export const ListsInputRulesExtension = (builder, options) => {
    builder.addInputRules(({ schema }) => {
        const rules = [orderedListRule(olType(schema))];
        if (options.bulletListInputRule !== false) {
            const blRule = bulletListRule(blType(schema), options.bulletListInputRule);
            if (blRule)
                rules.push(blRule);
        }
        return { rules };
    });
};
/**
 * Given a list node type, returns an input rule that turns a number
 * followed by a dot at the start of a textblock into an ordered list.
 */
export function orderedListRule(nodeType) {
    return wrappingInputRule(/^(\d+)\.\s$/, nodeType, (match) => ({ order: Number(match[1]) }), (match, node) => node.childCount + node.attrs.order === Number(match[1]));
}
/**
 * Given a list node type, returns an input rule that turns a bullet
 * (dash, plus, or asterisk) at the start of a textblock into a
 * bullet list.
 */
export function bulletListRule(nodeType, config) {
    const bullets = [];
    if ((config === null || config === void 0 ? void 0 : config.dash) !== false)
        bullets.push('-');
    if ((config === null || config === void 0 ? void 0 : config.plus) !== false)
        bullets.push('+');
    if ((config === null || config === void 0 ? void 0 : config.asterisk) !== false)
        bullets.push('*');
    if (bullets.length === 0)
        return null;
    const regexp = new RegExp(`^\\s*([${bullets.join('')}])\\s$`); // same as /^\s*([-+*])\s$/
    return wrappingInputRule(regexp, nodeType);
}
